import Skeleton from '@mui/material/Skeleton';

export default function EventPreviewSkeleton() {
    return (
        <div style={{ flex: '1', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <div style={{ alignSelf: 'stretch', display: 'flex' }}>
                <Skeleton
                    variant="rounded"
                    height={330}
                    sx={{
                        flex: '1',
                        backgroundColor: 'rgba(0, 0, 0, 0.4)',
                        borderRadius: '2rem'
                    }}
                />
            </div>

            <div
                style={{
                    display: 'flex',
                    alignSelf: 'stretch',
                    justifyContent: 'space-between',
                    gap: '1rem'
                }}
            >
                <div style={{ flex: '1', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    <Skeleton
                        variant="rounded"
                        // width={210}
                        height={300}
                        sx={{
                            alignSelf: 'stretch',
                            backgroundColor: 'rgba(0, 0, 0, 0.4)',
                            borderRadius: '2rem'
                        }}
                    />
                    <Skeleton
                        variant="rounded"
                        height={50}
                        sx={{
                            alignSelf: 'stretch',
                            backgroundColor: 'rgba(0, 0, 0, 0.4)',
                            borderRadius: '2rem'
                        }}
                    />
                    <Skeleton
                        variant="rounded"
                        height={50}
                        sx={{
                            alignSelf: 'stretch',
                            backgroundColor: 'rgba(0, 0, 0, 0.4)',
                            borderRadius: '2rem'
                        }}
                    />
                </div>
                <div
                    style={{
                        width: '460px',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '1rem'
                    }}
                >
                    <Skeleton
                        variant="rounded"
                        height={300}
                        sx={{
                            alignSelf: 'stretch',
                            backgroundColor: 'rgba(0, 0, 0, 0.4)',
                            borderRadius: '2rem'
                        }}
                    />
                    <Skeleton
                        variant="rounded"
                        height={100}
                        sx={{
                            alignSelf: 'stretch',
                            backgroundColor: 'rgba(0, 0, 0, 0.4)',
                            borderRadius: '2rem'
                        }}
                    />
                    <Skeleton
                        variant="rounded"
                        height={300}
                        sx={{
                            alignSelf: 'stretch',
                            backgroundColor: 'rgba(0, 0, 0, 0.4)',
                            borderRadius: '2rem'
                        }}
                    />
                    <Skeleton
                        variant="rounded"
                        height={100}
                        sx={{
                            alignSelf: 'stretch',
                            backgroundColor: 'rgba(0, 0, 0, 0.4)',
                            borderRadius: '2rem'
                        }}
                    />
                </div>
            </div>
        </div>
    );
}
